module.exports = __webpack_public_path__ + "static/patient-david-profile-img-0ee960901fc41c140cc1d8be96a16a50.jpg";